import moment from "moment";
import React, { useState } from "react";
import { FaCalendarAlt } from "react-icons/fa";
import DatePicker from "react-datepicker";
import { formatOfDate } from "../../utils/dateAndTimeConversion";
import { useTranslation } from "react-i18next";

const initialDate = {
  startDate: "",
  endDate: "",
};

const CancelReservationModal = ({ show, onClose }) => {
  const { t } = useTranslation();
  const [date, setDate] = useState(initialDate);
  const [reason, setReason] = useState("");
  const [selected, setSelected] = useState([]);

  const students = [
    { name: "Isaac English", roll: "SID000033" },
    { name: "Ori Espinoza", roll: "SID000034" },
    { name: "Eagan Silva", roll: "SID000035" },
    { name: "Pyto Pina", roll: "SID000036" },
  ];

  const handleSelect = (roll) => {
    setSelected((prev) =>
      prev.includes(roll) ? prev.filter((id) => id !== roll) : [...prev, roll]
    );
  };

  const handleDateChange = (selectedDate, field) => {
    setDate((prev) => {
      const adjustedDate = moment(selectedDate).startOf("day").toDate();
      const formattedDate = adjustedDate ? formatOfDate(adjustedDate) : "";
      const newDates = { ...prev, [field]: formattedDate };

      if (
        field === "startDate" &&
        newDates.endDate &&
        formattedDate > newDates.endDate
      ) {
        newDates.endDate = "";
      }

      return newDates;
    });
  };

  return (
    <div>
      <div className="date-inputs d-flex gap-3 mb-3">
        <div className="flex-fill">
          <label className="form-label">
            {t("start")} {t("date")}
          </label>
          <div className="position-relative">
            <DatePicker
              className="form-control"
              selected={
                date.startDate
                  ? moment(date.startDate, "YYYY-MM-DD").toDate()
                  : null
              }
              onChange={(selectedDate) =>
                handleDateChange(selectedDate, "startDate")
              }
              selectsStart
              startDate={
                date.startDate
                  ? moment(date.startDate, "YYYY-MM-DD").toDate()
                  : null
              }
              endDate={
                date.endDate
                  ? moment(date.endDate, "YYYY-MM-DD").toDate()
                  : null
              }
              // minDate={moment().toDate()}
              dateFormat="yyyy-MM-dd"
              placeholderText={`${t("select")} ${t("start")} ${t("date")}`}
            />

            <FaCalendarAlt className="calederIcon" />
          </div>
        </div>
        <div className="flex-fill">
          <label className="form-label">
            {t("end")} {t("date")}
          </label>
          <div className="position-relative">
            <DatePicker
              className="form-control"
              selected={
                date.endDate
                  ? moment(date.endDate, "YYYY-MM-DD").toDate()
                  : null
              }
              onChange={(selectedDate) =>
                handleDateChange(selectedDate, "endDate")
              }
              selectsEnd
              startDate={
                date.startDate
                  ? moment(date.startDate, "YYYY-MM-DD").toDate()
                  : null
              }
              endDate={
                date.endDate
                  ? moment(date.endDate, "YYYY-MM-DD").toDate()
                  : null
              }
              minDate={
                date.startDate
                  ? moment(date.startDate, "YYYY-MM-DD").toDate()
                  : new Date()
              }
              dateFormat="yyyy-MM-dd"
              placeholderText={`${t("select")} ${t("end")} ${t("date")}`}
              disabled={!date.startDate}
            />
            <FaCalendarAlt className="calederIcon" />
          </div>
        </div>
      </div>

      <div className="reason-box mb-3">
        <label className="form-label">
          {t("reason")} {t("for")} {t("cancellation")}
        </label>
        <textarea
          className="form-control"
          placeholder={`${t("please")} ${t("provide")} ${t("A")} ${t(
            "Reason"
          )} ${t("For")} ${t("Cancellation")}...`}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          rows={3}
        />
      </div>

      <div className="children-list mb-3">
        <h5 className="mb-2">
          {t("select")} {t("students")}
        </h5>
        <div className="d-flex flex-column gap-2">
          {students.map((child) => (
            <label
              key={child.roll}
              className="d-flex justify-content-between align-items-center p-2 border rounded"
            >
              <div>
                <strong>{child.name}</strong>
                <div className="text-muted small">
                  {t("roll")}: {child.roll}
                </div>
              </div>
              <input
                type="checkbox"
                checked={selected.includes(child.roll)}
                onChange={() => handleSelect(child.roll)}
              />
            </label>
          ))}
        </div>
      </div>

      <div className="modal-actions d-flex justify-content-end gap-2">
        <button className="btn btn-outline-secondary" onClick={onClose}>
          {t("btns.close")}
        </button>
        <button className="btn btn-primary">{t("btns.confirm")}</button>
      </div>
    </div>
  );
};

export default CancelReservationModal;
